import { type FC } from 'react';

import { StyledAnchor, StyledRouterLink } from './Link.styled';
import type { LinkProps } from './types';

const Link: FC<LinkProps> = ({ size = 'regular', to, href, children, ...rest }) => {
  if (to !== undefined) {
    return (
      <StyledRouterLink $size={size} to={to} {...rest}>
        {children}
      </StyledRouterLink>
    );
  }

  return (
    <StyledAnchor $size={size} href={href} {...rest}>
      {children}
    </StyledAnchor>
  );
};

Link.displayName = 'Link';

export default Link;
